export const GENRE_VALUES = ["horror", "romance", "sci_fi", "fantasy", "thriller", "comedy", "mystery", "crime", "adventure"];
export const Genre = {
    HORROR: "horror",
    ROMANCE: "romance",
    SCI_FI: "sci_fi",
    FANTASY: "fantasy",
    THRILLER: "thriller",
    COMEDY: "comedy",
    MYSTERY: "mystery",
    CRIME: "crime",
    ADVENTURE: "adventure",
};
export const GENRE_LABELS = {
    [Genre.HORROR]: "Horror",
    [Genre.ROMANCE]: "Romance",
    [Genre.SCI_FI]: "Sci-Fi",
    [Genre.FANTASY]: "Fantasy",
    [Genre.THRILLER]: "Thriller",
    [Genre.COMEDY]: "Comedy",
    [Genre.MYSTERY]: "Mystery",
    [Genre.CRIME]: "Crime",
    [Genre.ADVENTURE]: "Adventure",
};
